import { render } from "./App.vue?vue&type=template&id=4da8cb1a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4da8cb1a&lang=scss"
import "./App.vue?vue&type=style&index=1&id=4da8cb1a&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da8cb1a"]])

export default __exports__